import { SessionStorage } from "./storage";
var activeSystemKey = "activeSystem";
var UserSessionStorage = /** @class */ (function () {
    function UserSessionStorage() {
    }
    UserSessionStorage.setActiveSystem = function (system) {
        if (!system) {
            SessionStorage.removeItem(activeSystemKey);
            return;
        }
        SessionStorage.setItem(activeSystemKey, system);
    };
    UserSessionStorage.getActiveSystem = function () {
        return SessionStorage.getItem(activeSystemKey);
    };
    return UserSessionStorage;
}());
export { UserSessionStorage };
